"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var capitalize = function capitalize(s) {
    return s.charAt(0).toUpperCase() + s.slice(1);
};
exports.default = capitalize;
